import constants from '../config/constants.js';
const $inject = [];

const dataSourceService = function () {
  const service = {
    dataSource: constants.DATA_SOURCES.ODATA
  };

  return service;
};

dataSourceService.$inject = $inject;

export default dataSourceService;



// WEBPACK FOOTER //
// ./src/services/dataSourceService.js